import type {
  MobileNavigationAccount,
  MobileNavigationMenu,
  MobileNavigationSupport,
} from './types';
import AccountActions from './AccountActions';

interface MenuFooterProps {
  account: MobileNavigationAccount | null;
  support: MobileNavigationSupport | null;
  engage: MobileNavigationMenu['engage'];
}

export default function MenuFooter({
  account,
  support,
  engage,
}: MenuFooterProps) {
  return (
    <>
      {account && <AccountActions account={account} />}
      {support && (
        <div className="bio-mobile-menu__support">
          <h2 className="bio-mobile-menu__support-title">{support.title}</h2>
          {support.links.map((supportLink) => (
            <a
              key={supportLink.href}
              className="bio-mobile-menu__support-link"
              href={supportLink.href}
            >
              {supportLink.label}
            </a>
          ))}
          <a
            className="bio-mobile-menu__button bio-mobile-menu__button--clinical"
            href={support.clinical.href}
          >
            {support.clinical.label}
          </a>
        </div>
      )}
      {engage && (
        <a className="bio-mobile-menu__engage" href={engage.href}>
          <img src={engage.src} alt={engage.alt} />
        </a>
      )}
    </>
  );
}
